export default __webpack_public_path__ + "static/media/fa-brands-400.37913cdf.woff2";